'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../types/brand.js');
var enums = require('../types/cms/enums.js');

const sendMessageToParent = (origin, action, context) => {
    window.parent.postMessage({
        source: enums.MessageSources.PREVIEW_APPLICATION,
        action,
        context
    }, origin);
};

exports.sendMessageToParent = sendMessageToParent;
//# sourceMappingURL=windowMessaging.js.map
